import { IPuenteProps } from '../puente';

function puenteAdapter(data: any): IPuenteProps {
    return {
        img: data.imagenPrincipal ? data.imagenPrincipal.file.url : '',
        marginTop: data.tituloBoton ? data.tituloBoton : '0',
        marginBottom: data.redireccionBoton ? data.redireccionBoton : '0',
    };
}

export default puenteAdapter;
